import '.eu{font-size:1.125rem;}.ssr-plugin'
import '.ed{line-height:1.75rem;}.ssr-plugin'
import '.hw{text-decoration:none;}.ssr-plugin'
import '.fi{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="eu ed"
    >
      {translations.privacySubtitle}{' '}
      <a className="hw fi"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="hw fi"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
